import { render, staticRenderFns } from "./cancelTicket.vue?vue&type=template&id=53057078"
import script from "./cancelTicket.vue?vue&type=script&lang=js"
export * from "./cancelTicket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports